import React from "react";

const SignupThanks = () => {
  return (
    <section className="section form-section section-block">
      <div className="tc mb40">
        <p>
          この度はマイページへのご登録を頂き
          <br />
          ありがとうございます。
        </p>
        <br />
        <p>
          <b className="bold" style={{color: "red"}}>ご入力いただいた内容は即時反映はされません。</b>
          <br />
          数営業日以内に登録が完了致しますので、反映をお待ちください。
        </p>
      </div>

      <div className="btn-orange mb0">
        <a href="/">ログインページへ</a>
      </div>
    </section>
  );
};

export default SignupThanks;